import { render, staticRenderFns } from "./ModalEditMember.vue?vue&type=template&id=5dd646ed&scoped=true"
import script from "./ModalEditMember.vue?vue&type=script&lang=js"
export * from "./ModalEditMember.vue?vue&type=script&lang=js"
import style0 from "./ModalEditMember.vue?vue&type=style&index=0&id=5dd646ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd646ed",
  null
  
)

export default component.exports